/*
 * Customization with image
 */

// eslint-disable-next-line import/no-unresolved
import logo from 'fontanelice-theme/components/Logo/logo.jpeg?width=148';

const LogoFooter = () => (
  <img
    className="logo-footer"
    src={logo}
    width="74"
    height="82"
    alt="Logo"
    loading="lazy"
    decoding="async"
  />
);

export default LogoFooter;
